import FilteredCaption from './FilteredCaption';
import { CAPTION_FONT_SIZE } from './constants';

const voyagers_text = (num_people) => (num_people === 1) ? `1 voyager` : `${num_people} voyagers`;

const TripCaption = ({ trip }) => {

    if (trip === null) {
        return <></>;
    }

    let num_people = 0;
    let filtered_num_people = 0;
    for (let pt in trip.person_trips) {
      num_people += trip.person_trips[pt].person.group_size;
      // person_trip.in_filter means "this person and this trip are both in the
      // filter", so it is the only flag this needs to check.
      if (trip.person_trips[pt].in_filter) {
        filtered_num_people += trip.person_trips[pt].person.group_size;
      }
    }

    return (
      <g fill="white"
         textAnchor="middle"
         className="trip_caption"
         style={{fontSize: CAPTION_FONT_SIZE}}>
        <text dy="-0.45em">{trip.trip_key_memory}</text>
        <text dy="1.15em">{trip.trip_date}</text>
        <text dy="2.75em">{voyagers_text(num_people)}</text>
        {filtered_num_people !== num_people &&
          <FilteredCaption text={voyagers_text(filtered_num_people)} dy="4.35em" />}
      </g>
    );
  };

  export default TripCaption;
